// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("/src/assets/billetera.svg", import.meta.url);
// Module
var code = `<div class="ventajas"
    id="ventajas">

    <div class="ventajas__box">
        <div class="container">

            <!-- TÍTULO -->
            <div class="row">
                <div class="col-12 ventajas__header">
                    <h2 ng-bind-html="\$ctrl.ventajas.title"
                        class="ventajas__title">
                    </h2>
                    <p class="ventajas__subtitle">
                        {{\$ctrl.ventajas.subtitle}}
                    </p>
                </div>
            </div>

            <!-- CONTENIDO -->
            <div class="row ventajas__content justify-content-xl-around">

                <!-- LEFT -->
                <div class="col-lg-3 ventajas__column ventajas__column--left">
                    <div class="d-flex align-items-center d-lg-block text-lg-center ventajas__item-box ventajas__item"
                        ng-repeat="item in \$ctrl.listLeft">

                        <img ng-src="{{item.image}}"
                            class="ventajas__item-image" />

                        <div class="ventajas__item-content">
                            <h4 class="ventajas__item-title">{{item.title}}</h4>
                            <div ng-bind-html="item.subtitle"
                                class="ventajas__item-subtitle"></div>
                        </div>

                    </div>

                </div>

                <!-- IMAGE -->
                <div class="col-lg-6 col-xl-5 d-none d-lg-flex ventajas__image">
                    <img ng-src=" {{\$ctrl.ventajas.image}}"
                        alt="Ventajas Toke"
                        class="img-fluid" />
                </div>

                <!-- RIGHT -->
                <div class="col-lg-3  ventajas__column ventajas__column--right">
                    <div class="ventajas__item d-flex align-items-center d-lg-block text-lg-center ventajas__item-box"
                        ng-repeat="item in \$ctrl.listRight">

                        <img ng-src="{{item.image}}"
                            class="ventajas__item-image" />

                        <div class="ventajas__item-content">
                            <h4 class="ventajas__item-title">{{item.title}}</h4>
                            <div ng-bind-html="item.subtitle"
                                class="ventajas__item-subtitle"></div>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <img class="ventajas__decal d-none d-xl-block"
        src="${___HTML_LOADER_IMPORT_0___}"
        alt="billetera">
</div>

</div>`;
// Exports
export default code;